import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';
import { CrewQuestionnaire, useCrewQuestionnaire } from './useData';

const Detail: React.FC = () => <GenericDetailPage<CrewQuestionnaire> useData={useCrewQuestionnaire} config={{ ...moduleConfig, getDetailSections, getStatusBadges }} />;
export default Detail;
